require('./intervenerRow.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');

class IntervenerRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange (evt) {
        const { id, onTypeChange } = this.props;
        onTypeChange(id, evt.value);
    }

    handleClick () {
        const { id, onExclude } = this.props;
        onExclude(id);
    }

    render () {
        const {
            intervenerName,
            relationship,
            showError,
            showRemoveButton
        } = this.props;
        let removeButton = null;

        const RELATIONSHIP_OPTIONS = [
            {
                value: 0, label: formatText('contractsView-father')
            },
            {
                value: 1, label: formatText('contractsView-mother')
            },
            {
                value: 2, label: formatText('contractsView-guardian')
            }
        ];


        if (showRemoveButton){
            removeButton = (
                <div className="intervener-row__exclude-button">
                    <OKButton
                        leftIcon="icon-quitar"
                        modifier="ghost"
                        onClick={this.handleClick}
                    >
                        <FormattedText value="contractsView-exclude" />
                    </OKButton>
                </div>
            );
        }

        return (
            <div className="intervener-row">
                <div className="intervener-row__intervener">
                    <p className="junior-interveners__intervener-name">{intervenerName}</p>
                    <FormattedText className="junior-interveners__sublabel" value="contractsView-legalRepresentative"/>
                </div>
                <div className="intervener-row__relationship">
                    <OKSelect
                        onChange={this.handleChange}
                        options={RELATIONSHIP_OPTIONS}
                        errorState={showError}
                        errorMessage={formatText('contractsView-juniorAccountDropdownErrorMsg')}
                        value={relationship}
                    />
                </div>
                {removeButton}
            </div>
        );
    }
}

IntervenerRow.propTypes = {
    intervenerName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onExclude: PropTypes.func.isRequired,
    relationship: PropTypes.number,
    showError: PropTypes.bool.isRequired,
    showRemoveButton: PropTypes.bool.isRequired
}

module.exports = IntervenerRow;
